import React from 'react';
import { ESTADO_LIGACAO } from './useSessaoAgora';

// Cobertura de "A ENTRAR NO ESTÁDIO..." e de erro de ligação.
//
// Antes, quando a entrada falhava ou ficava pendurada, o ecrã não dizia nada:
// ficavam duas janelas pretas para sempre. Agora ou está a entrar (com um
// limite de 15s garantido pelo gestor de sessão), ou está em campo, ou explica
// o que correu mal e dá um botão para tentar outra vez.

function EstadoLigacaoEstadio({ estado, mensagemErro, aoTentarDeNovo, aoSair }) {
  if (estado !== ESTADO_LIGACAO.A_ENTRAR && estado !== ESTADO_LIGACAO.ERRO) return null;

  const aEntrar = estado === ESTADO_LIGACAO.A_ENTRAR;

  return (
    <div
      className="notranslate"
      translate="no"
      style={{
        position: 'absolute',
        inset: 0,
        // Por cima das janelas de vídeo, por baixo do aviso diário (10000000).
        zIndex: 9000000,
        backgroundColor: 'rgba(0, 0, 0, 0.92)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '25px',
        textAlign: 'center',
        boxSizing: 'border-box',
      }}
    >
      <style>{`@keyframes girarBola { to { transform: rotate(360deg); } }`}</style>

      {aEntrar ? (
        <>
          <div style={{ fontSize: '40px', animation: 'girarBola 1.1s linear infinite' }}>⚽</div>
          <p style={{ color: '#39FF14', fontWeight: 900, fontSize: '14px', letterSpacing: '1px', marginTop: '16px' }}>
            A ENTRAR NO ESTÁDIO...
          </p>
        </>
      ) : (
        <>
          <div style={{ fontSize: '40px' }}>🟥</div>
          <p style={{ color: '#ff4444', fontWeight: 900, fontSize: '14px', letterSpacing: '1px', margin: '16px 0 8px 0' }}>
            NÃO FOI POSSÍVEL ENTRAR
          </p>
          <p style={{ color: '#ccc', fontSize: '12px', lineHeight: 1.5, maxWidth: '300px', margin: '0 0 22px 0' }}>
            {mensagemErro}
          </p>

          <button
            onClick={aoTentarDeNovo}
            style={{
              background: '#39FF14', color: '#000', border: 'none', borderRadius: '25px',
              padding: '13px 34px', fontWeight: 900, fontSize: '13px', cursor: 'pointer',
              boxShadow: '0 0 12px rgba(57, 255, 20, 0.5)', minWidth: '200px',
            }}
          >
            TENTAR DE NOVO ⚽
          </button>

          {typeof aoSair === 'function' && (
            <button
              onClick={aoSair}
              style={{
                background: 'none', color: '#888', border: 'none', marginTop: '14px',
                fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'underline',
              }}
            >
              Sair do estádio
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default EstadoLigacaoEstadio;
